import React, { ComponentProps } from "react";
import {
  FormattedMessage as ReactIntlFormattedMessage,
  MessageDescriptor,
} from "react-intl";

export type Message = MessageDescriptor;

export interface FormattedMessageProps
  extends Omit<
    ComponentProps<typeof ReactIntlFormattedMessage>,
    keyof Message
  > {
  message: Message;
}

export const FormattedMessage = ({
  message,
  ...props
}: FormattedMessageProps) => {
  if (!message.id || message.id.toString().match(/[^.a-zA-Z]/)) {
    throw Error(
      "Message IDs should only contain letters and dots. The preferred ID pattern is `ComponentName.messageName`."
    );
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReactIntlFormattedMessage {...message} {...props} />;
};

FormattedMessage.displayName = "FormattedMessage";
